import { darkModalOutline } from "Styles/darkModal";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  position: fixed;
  top: 30px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  min-width: 700px;

  width: fit-content;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.neutral.black};
  padding: 25px;

  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;

  ${media.lessThan("medium")`
    position: relative;
    top: 14px;
    min-width: 100%;
    width: 100%;
    height: 100%;
  `}

  /* Contorno: sem ele o modal se funde ao fundo preto da pagina. */
  ${darkModalOutline}
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.neutral.white};
    width: 180px;
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.neutral.white};
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${media.lessThan("medium")`
    flex-direction: column;
    gap: 10px;
  `}
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  margin-bottom: 20px;

  span {
    font-size: 16px;
  }
`;

export const QuotasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 70%;

  margin-bottom: 20px;

  ${media.lessThan("medium")`
    width: 100%;
    flex-wrap: wrap;
  `}
`;

export const QuotaColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  h3 {
    font-size: 14px;
  }
`;

export const Quota = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: center;

  width: 100%;

  span {
    font-size: 14px;
  }
`;

export const Uf = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Cities = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const City = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.black};

  display: flex;
  align-items: center;
  gap: 5px;
`;

export const File = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.white};
  border-radius: 5px;

  h2 {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  a {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.white};
    text-decoration: underline;
  }
`;

export const FileInfos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

// --- Link externo no Álbum (B05, 03/09/2026) -------------------------------

export const LinkHint = styled.p`
  margin-bottom: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral.cinza200};
`;

export const LinkFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-bottom: 16px;

  input {
    padding: 10px;

    border: 1px solid ${({ theme }) => theme.colors.neutral.cinza600};
    border-radius: 4px;

    background-color: transparent;
    color: ${({ theme }) => theme.colors.neutral.white};

    ::placeholder {
      color: ${({ theme }) => theme.colors.neutral.cinza200};
    }
  }
`;

export const LinkError = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.feedback.error};
`;
